import type moment from 'moment-timezone';

export type CancelOption = 'single' | 'multiple';

export type CancelReservationModalProps = {
  open: boolean;
  afterOpenChange?: (open: boolean) => void;
  onClose: () => void;
  onConfirm: (option: CancelOption, shouldCancelVisits: boolean) => void;
  reservationInProgress: boolean;
  reservationStartDate: moment.Moment;
  reservationTimezone: string;
  reservationId: string;
  reservationSeriesId?: string | null;
  deskName: string;
  buildingName: string;
  floorName?: string;
  reservationUserId?: string;
  reservationUserName?: string | null;
  reservationReserverName?: string | null;
  showDelegatedWarning?: boolean;
  showMultipleOption?: boolean;
  seriesDates?: moment.Moment[];
  reservationDates?: moment.Moment[];
  loading?: boolean;
};

export type CancelReservationSeriesModalProps = CancelReservationModalProps & {
  reservationSeriesId: string;
};

export const isSeriesModalProps = (
  props: CancelReservationModalProps
): props is CancelReservationSeriesModalProps =>
  Boolean(props.reservationSeriesId);
